import { extend, $$, $, addEvent } from './helper-functions'

export class QuoteSlider {
  constructor (settings, selectors, classes, texts) {
    this.settings = extend({
      endless: true
    }, settings)

    this.selectors = extend({
      block: '.quote-slider',
      container: '.quote-slider__container',
      item: '.quote-slider__item',
      prevButton: '.quote-slider__prev-button',
      nextButton: '.quote-slider__next-button'
    }, selectors)

    this.classes = extend({
      navigation: 'quote-slider__navigation',
      prevButton: 'quote-slider__prev-button',
      nextButton: 'quote-slider__next-button',
      active: 'quote-slider--active'
    }, classes)

    this.texts = extend({
      prevButton: 'Zurück',
      nextButton: 'Weiter'
    }, texts)
  }

  init () {
    this.quoteSliders = $$(this.selectors.block)
    this.setHTML()
    this.events()
  }

  setHTML () {
    this.quoteSliders.forEach((quoteSlider) => {
      const items = $$(this.selectors.item, quoteSlider)
      const container = $(this.selectors.container, quoteSlider)

      this.activateSlide(quoteSlider, 0)

      if (items.length > 1) {
        const navigation = document.createElement('div')
        const prevButton = document.createElement('button')
        const nextButton = document.createElement('button')
        navigation.classList.add(this.classes.navigation)
        prevButton.classList.add(this.classes.prevButton)
        prevButton.textContent = this.texts.prevButton
        prevButton.setAttribute('title', this.texts.prevButton)
        nextButton.classList.add(this.classes.nextButton)
        nextButton.textContent = this.texts.nextButton
        nextButton.setAttribute('title', this.texts.nextButton)
        navigation.appendChild(prevButton)
        navigation.appendChild(nextButton)
        container.appendChild(navigation)
      }
    })
  }

  activateSlide (block, itemCount) {
    const items = $$(this.selectors.item, block)
    itemCount = parseInt(itemCount)

    if ((itemCount + 1) > items.length) {
      if (this.settings.endless === true) {
        itemCount = 0
      } else {
        itemCount = items.length - 1
      }
    } else if (itemCount < 0) {
      if (this.settings.endless === true) {
        itemCount = items.length - 1
      } else {
        itemCount = 0
      }
    }

    block.dataset.activeItem = itemCount

    items.forEach((item, index) => {
      item.classList.toggle(this.classes.active, index === itemCount)
    })
  }

  nextSlide (block) {
    this.activateSlide(block, parseInt(block.dataset.activeItem) + 1)
  }

  prevSlide (block) {
    this.activateSlide(block, parseInt(block.dataset.activeItem) - 1)
  }

  events () {
    const prevButtons = $$(this.selectors.prevButton)
    const nextButtons = $$(this.selectors.nextButton)

    prevButtons.forEach((prevButton) => {
      addEvent(prevButton, 'click', (event) => {
        const block = prevButton.closest(this.selectors.block)
        this.prevSlide(block)
      })
    })

    nextButtons.forEach((nextButton) => {
      addEvent(nextButton, 'click', (event) => {
        const block = nextButton.closest(this.selectors.block)
        this.nextSlide(block)
      })
    })
  }
}

export default QuoteSlider
